import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { findIndex } from "./Utils";

gsap.registerPlugin(Draggable);

class DragToSpot {
  constructor(el, callback, maxCount = 3) {
    this.el = el;
    this.callback = callback;
    this.dragFreeOverlapThreshold = "25%";
    this.dragFreeformContainer = document.querySelector(this.el);
    this.dragFreeformDroppables =
      this.dragFreeformContainer.querySelectorAll(".draggable");
    this.dragFreeformDropZones =
      this.dragFreeformContainer.querySelectorAll(".dropzone");
    this.dragFreeformDropZoneLabels =
      this.dragFreeformContainer.querySelectorAll(".dropzoneLabel");
    this.dragFreeformOccupiedZones = [];
    this.dragFreeformInsideZone = false;
    this.dragFreeformCurrentZone = null;
    this.dragFreeformPreviousZone = null;
    this.dragMaxCount = maxCount;
    this.dragFreeformCount = 0;
    this.that = this;
    this.init();
  }
  init() {
    this.dragFreeformDroppables.forEach((el) => {
      Draggable.create(el, {
        onDragParams: [this.that],
        onDragEndParams: [this.that],

        onDrag: function (parent) {
          for (var i = 0; i < parent.dragFreeformDropZones.length; i++) {
            if (
              this.hitTest(
                parent.dragFreeformDropZones[i],
                parent.dragFreeOverlapThreshold
              )
            ) {
              parent.dragFreeformCurrentZone = parent.dragFreeformDropZones[i];
              parent.dragFreeformInsideZone = true;
              break;
            } else {
              parent.dragFreeformInsideZone = false;
            }
          }
        },

        onDragEnd: function (parent) {
          // if released outside of a zone
          if (parent.dragFreeformCurrentZone == null) {
            gsap.to(this.target, { duration: 0.2, x: 0, y: 0 });
            return;
          }

          // elems
          let id = -1;
          let product = this.target.dataset.product;
          let slot = parent.dragFreeformCurrentZone.dataset.slot;
          let index = findIndex(parent.dragFreeformOccupiedZones, product);

          // get current zone id
          if (parent.dragFreeformCurrentZone !== null) {
            id = slot - 1; // as array starts at 0.
          }

          // if zone already occupied
          let slotOccupied = findIndex(parent.dragFreeformOccupiedZones, slot);
          if (slotOccupied !== -1) {
            gsap.to(this.target, { duration: 0.2, x: 0, y: 0 });
            return;
          }

          // if released outside of a zone
          if (
            !parent.dragFreeformInsideZone ||
            parent.dragFreeformCurrentZone == null
          ) {
            gsap.to(this.target, { duration: 0.2, x: 0, y: 0 });
            return;
          }

          // push to the array
          parent.dragFreeformOccupiedZones.push([slot, product]);

          // increment count
          parent.dragFreeformCount = parent.dragFreeformCount + 1;

          // tween to correct position
          let dragElPos = this.target.getBoundingClientRect();
          let dropElPos =
            parent.dragFreeformCurrentZone.getBoundingClientRect();
          let x = "+=" + (dropElPos.left - dragElPos.left);
          let y = "+=" + (dropElPos.top - dragElPos.top);
          gsap.to(this.target, {
            duration: 0.3,
            x: x,
            y: y,
            onComplete: () => {
              if (parent.dragFreeformCurrentZone) {
                let index = parent.dragFreeformCurrentZone.dataset.slot;
                if (index && parent.dragFreeformDropZoneLabels.length > 0) {
                  gsap.set(parent.dragFreeformDropZoneLabels[index], {
                    opacity: 1,
                  });
                }
              }

              // stop drag
              Draggable.get(this.target).disable();

              // reset
              parent.dragFreeformPreviousZone = parent.dragFreeformCurrentZone;
              parent.dragFreeformCurrentZone = null;
            },
          });

          // perform callback
          if (parent.dragFreeformCount == parent.dragMaxCount) {
            parent.callback();
          }
        },
      });
    });
  }

  reset() {
    this.dragFreeformOccupiedZones = [];
    this.dragFreeformInsideZone = false;
    this.dragFreeformCurrentZone = null;
    this.dragFreeformPreviousZone = null;
    this.dragFreeformCount = 0;
    this.dragFreeformDroppables.forEach((el) => {
      gsap.set(el, { x: 0, y: 0, opacity: 1 });
      Draggable.get(el).enable();
    });
    this.dragFreeformDropZoneLabels.forEach((el) => {
      gsap.set(el, { clearProps: "all" });
    });
  }
}

export { DragToSpot };
